const MatchExpert = {
  tableConfig: {
    showCheckbox: true,
    minWidth: 2150
  },
  queryList: [
    {
      name: 'batchName',
      label: '批次',
      component: 'input'
    },
    {
      name: 'unitName',
      label: '学校名称',
      component: 'input'
    },
    {
      name: 'academyName',
      label: '院系名称',
      component: 'input'
    },
    {
      name: 'firstSubjectName',
      label: '一级学科',
      component: 'select',
      request: {
        method: 'post',
        addr: '/conf/confFirstSubject/all',
        data: {},
        format: {
          value: 'name',
          label: 'name'
        }
      }
    },
    {
      name: 'secondSubjectName',
      label: '二级学科',
      component: 'select',
      request: {
        method: 'post',
        addr: '/conf/confSecondSubject/all',
        data: {},
        format: {
          value: 'name',
          label: 'name'
        }
      }
    },
    {
      name: 'schoolNo',
      label: '学号',
      component: 'input'
    },
    {
      name: 'authorName',
      label: '姓名',
      component: 'input'
    },
    {
      name: 'subTime',
      label: '提交时间',
      component: 'dateRange'
    },
    {
      name: 'titleCn',
      label: '论文题目',
      component: 'input'
    },
    // {
    //   name: 'sendState',
    //   label: '当前状态',
    //   component: 'select',
    //   componentAttr: {
    //     options: [{
    //       value: '0',
    //       label: '未完成送审'
    //     }, {
    //       value: '1',
    //       label: '已完成送审'
    //     }]
    //   }
    // },
    // {
    //   name: 'zpState',
    //   label: '匹配状态',
    //   component: 'select',
    //   componentAttr: {
    //     options: [{
    //       value: 1,
    //       label: '完成'
    //     }, {
    //       value: 2,
    //       label: '待指派'
    //     }]
    //   }
    // },
    {
      name: 'completeFlag',
      label: '完成指派',
      component: 'select',
      componentAttr: {
        options: [{
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }]
      }
    },
    {
      name: 'sendFlag',
      label: '完成送审',
      component: 'select',
      componentAttr: {
        options: [{
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }]
      }
    },
    {
      name: 'extSendFlag',
      label: '是否加送',
      component: 'select',
      componentAttr: {
        options: [{
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }]
      }
    }
  ],
  urlMap: {
    'select': '/custom/sendPaper/list'
  },
  operList: [// 操作列表
    // {
    //   name: 'autoMatch',
    //   label: '自动匹配专家',
    //   show: true,已安排专家
    //   action: {
    //     type: 'request',
    //     addr: '/custom/sendPaper/match',
    //     data: '{searchParam}'
    //   }
    // },
    {
      name: 'batchMatch',
      label: '批量指派专家',
      show: true,
      action: {
        type: 'func',
        addr: 'recordSelectedAndJump',
        data: {
          name: 'batchSendThesisIds',
          addr: 'thesisManage/batchMatchExpert'
        }
      }
    },
    {
      name: 'batchMatchUnit',
      label: '批量指派单位',
      show: true,
      action: {
        type: 'func',
        addr: 'recordSelectedAndJump',
        data: {
          name: 'batchSendThesisIds',
          addr: 'thesisManage/batchMatchUnit'
        }
      }
    },
    {
      name: 'chooseReview',
      label: '选中送审',
      show: true,
      action: {
        type: 'request',
        method: 'post',
        data: '("{tableSelectionIds}").split(",")',
        addr: '/custom/sendPaper/sendSelected'
      }
    },
    {
      name: 'allReview',
      label: '全部送审',
      show: true,
      action: {
        type: 'request',
        addr: '/custom/sendPaper/sendAll',
        data: '{searchParam}'
      }
    }
  ],
  titles: [
    {
      name: 'id',
      key: true
    },
    {
      name: 'year',
      width: 100,
      label: '年份'
    },
    {
      name: 'quarter',
      width: 100,
      label: '季度'
    },
    {
      name: 'batchName',
      width: 100,
      label: '批次'
    },
    {
      name: 'unitName',
      width: 100,
      label: '学校名称'
    },
    {
      name: 'academyName',
      width: 100,
      label: '所在学院'
    },
    {
      name: 'titleCn',
      label: '论文题目',
      width: 100
    },
    {
      name: 'firstSubjectName',
      width: 95,
      label: '一级学科'
    },
    {
      name: 'secondSubjectName',
      width: 150,
      label: '二级学科'
    },
    {
      name: 'schoolNo',
      width: 150,
      label: '学号'
    },
    {
      name: 'authorName',
      width: 80,
      label: '姓名'
    },
    {
      name: 'rate',
      width: 80,
      label: '送审数'
    },
    {
      name: 'expDTOList',
      label: '已安排专家',
      width: 250,
      type: 'array',
      action: {
        label: 'name',
        type: 'dialog',
        footerHide: true,
        width: 800,
        addr: 'systemManage/expertEdit?{id}&readonly'
      }
    },
    {
      name: 'receiveUnitList',
      width: 200,
      label: '已安排单位',
      type: 'array',
      action: {
        label: 'name',
        type: 'dialog',
        footerHide: true,
        width: 800
      }
    },
    {
      name: 'sendFlag',
      width: 100,
      label: '当前状态',
      map: {
        0: '未完成送审',
        1: '已完成送审'
      }
    },
    {
      name: 'submitTime',
      width: 150,
      label: '提交时间'
    },
    {
      name: 'reviewEndTime',
      width: 150,
      label: '论文截止评阅时间'
    },
    {
      name: 'operation',
      label: '操作',
      // width: 200,
      // fixed: 'right',
      actionList: [
        // {
        //   label: '指派专家',
        //   name: 'match',
        //   kind: 'primary', // error
        //   type: 'subRouter', // request, router, dialog, func
        //   addr: 'thesisManage/matchExpert?id={id}'
        // },
        {
          label: '详情',
          name: 'detail',
          kind: 'primary', // error
          type: 'subRouter', // request, router, dialog, func
          addr: 'thesisManage/matchExpert?id={id}&readonly'
        }
      ]
    }
  ]
}
export default MatchExpert



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/thesisManage/matchExpert.js